import type { SearchDriverStatus } from '../enums/SearchDriverStatus'

export class DriverAssignmentEntity {
  orderId?: string | null
  orderReferenceCode?: string | null
  status?: SearchDriverStatus
  notifiedAt?: string
  userId?: number
  userName?: string
  userPhoneNumber?: string
  mealId?: string | null
  mealReferenceCode?: string | null
}
